const initialState = {
    data: [],
  };
  
  const usterkiReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_USTERKI':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default usterkiReducer;